import React from "react";

const items = [
  {
    num: "01",
    title: "30+ Years of Trust",
    desc: "Three decades of honest craftsmanship in Rasta Peth — long enough to serve grandparents, parents, and now their children.",
  },
  {
    num: "02",
    title: "1,400+ Happy Families",
    desc: "A growing community of customers who return to us for every occasion, and who send their loved ones our way.",
  },
  {
    num: "03",
    title: "Designs That Outstand",
    desc: "Unique, one-of-a-kind pieces you won't find on every counter in the city — designed to be noticed and remembered.",
  },
  {
    num: "04",
    title: "First With the Latest Trends",
    desc: "From contemporary Italian and Turkish gold to timeless temple and antique jewellery — we track what's next.",
  },
  {
    num: "05",
    title: "A Wide, Honest Range",
    desc: "Gold, silver, diamond and rose gold — 14k to 24k — rings, chains, earrings, bangles and more, all under one roof.",
  },
  {
    num: "06",
    title: "Fair, Transparent Charges",
    desc: "Some of the lowest making charges in the market, with nothing hidden in your final bill.",
  },
];

export default function WhyUs() {
  return (
    <section className="why" id="why">
      <div className="wrap">
        <span className="eyebrow reveal">Why Alankar</span>
        <h2 className="reveal">
          Six reasons Pune families choose us, generation after generation.
        </h2>
        <div className="why-grid">
          {items.map((it) => (
            <div key={it.num} className="why-card reveal">
              <span className="num">{it.num}</span>
              <h3>{it.title}</h3>
              <p>{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
